import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';

import { Candidate, Company, Job } from '@shared/models';

import * as LayoutActions from './layout.actions';

export interface HeaderState {
  jobs: Job[];
  candidates: Candidate[];
  companies: Company[];
  search: string;
  loaded: boolean;
  loading: boolean;
}

export interface LayoutState {
  header: HeaderState;
}

export const initialState: HeaderState = {
  jobs: [],
  candidates: [],
  companies: [],
  search: '',
  loaded: false,
  loading: false,
};

export const LAYOUT_TOKEN = 'layout';

export const layoutReducers: ActionReducerMap<LayoutState, Action> = {
  header: createReducer(
    initialState,
    on(LayoutActions.layoutHeaderLoadGlobalSearch, (state, { search }) => ({ ...state, loading: true, search })),
    on(LayoutActions.layoutHeaderLoadGlobalSearchSuccess, (state, { candidates, jobs, companies }) => ({
      ...state,
      loaded: true,
      loading: false,
      candidates,
      jobs,
      companies,
    })),
    on(LayoutActions.layoutHeaderLoadGlobalSearchFail, (state) => ({ ...state, loaded: false, loading: false })),
    on(LayoutActions.layoutHeaderClearGlobalSearch, (state) => ({
      ...state,
      loaded: false,
      loading: false,
      search: '',
      candidates: [],
      jobs: [],
      companies: [],
    })),
  ),
};
